import { useQuery } from "@apollo/client";
import { GET_MY_SHOP_PRIMARY_STRATEGY } from "../graphql/queries";
import { useAuthUser } from "../contexts/AuthUserContext";

/**
 * Shared hook for fetching primary strategy data
 * This prevents duplicate API calls by using a consistent query with all required fields
 */
export const usePrimaryStrategy = (options = {}) => {
  const { user } = useAuthUser();
  const { skip = false, fetchPolicy = "cache-and-network" } = options;
  const authToken = user?.token;
  const headers = authToken ? { Authorization: `Bearer ${authToken}` } : {};

  const { data, loading, error, refetch } = useQuery(
    GET_MY_SHOP_PRIMARY_STRATEGY,
    {
      variables: {
        select: [
          // Basic fields needed by HomePage
          "primary_strategy.cluster_flag",
          "primary_strategy.recommended_strategy",
          "primary_strategy.isCompleted",

          // Complete fields needed by ZeqiStrategyReportSection
          "name",
          "email",
          "primary_strategy_id",
          "secondary_strategy_id",
          "primary_strategy.title",
          "primary_strategy.short_description",
          "primary_strategy.description",
          "primary_strategy.assessment_report",
          "primary_strategy.problem",
          "primary_strategy.research",
          "primary_strategy.cluster_flag",
          "primary_strategy.recommended_strategy",
          "primary_strategy.updatedAt",
          "primary_strategy.isCompleted",
          "secondary_strategy.title",
          "secondary_strategy.short_description",
          "secondary_strategy.description",
          "secondary_strategy.assessment_report",
          "secondary_strategy.problem",
          "secondary_strategy.research",
          "secondary_strategy.cluster_flag",
          "secondary_strategy.recommended_strategy",
          "secondary_strategy.updatedAt",
          "secondary_strategy.isCompleted",
        ],
      },
      skip: skip || !authToken,
      fetchPolicy,
      notifyOnNetworkStatusChange: true,
      context: { headers },
    },
  );

  const primary = data?.getMyShopPrimaryStrategy?.primary_strategy || null;
  const secondary = data?.getMyShopPrimaryStrategy?.secondary_strategy || null;
  const primaryCompleted = primary?.isCompleted === true;

  return {
    data,
    loading,
    error,
    refetch,
    primary,
    secondary,
    primaryCompleted,
  };
};
